module.exports = __webpack_public_path__ + "static/media/noticias-hombre.44589965.png";